import { Cartesian3, Math as CesiumMath } from "cesium";
import { PrismEntity } from "../services/entity-editors/map-entities-editor.service";

export function arePrismEntitiesPositionsEqual(left: PrismEntity, right: PrismEntity): boolean {
    if (left.positions.length !== right.positions.length) {
        return false;
    }

    for (let index = 0; index < left.positions.length; index++) {
        if (!Cartesian3.equalsEpsilon(left.positions[index], right.positions[index], CesiumMath.EPSILON6)) {
            return false;
        }
    }

    return true;
}
